import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import QS from 'qs'

import state from './state.js'
import actions from './actions.js'
import mutations from './mutations.js'
import getters from './getters.js'

import settingsAndCustomize from "./modules/settingsAndCustomize/index"
import donateBloodAppointments from "./modules/donateBloodAppointments/index";
import donorInformation from "./modules/donorInformation/index.js"
import auth from "./modules/auth/index.js"
import communication from "./modules/communication/index.js"
import rewards from "./modules/rewards/index.js";
import pages from "./modules/pages/index.js";
//import xlooLib from "../xlooLib/xlooLib"


Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.use(QS)

//Vue.use(xlooLib);

Vue.use(Vuex);
export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {settingsAndCustomize, donateBloodAppointments, donorInformation, auth, communication, rewards, pages},
});
